import { type Component, createSSRApp, nextTick } from 'vue';
import App from './App.vue';
import { router } from './router';

import { loginWithTicket } from './modules/passport-auth';
import { exportUserToMyApps } from './modules/my-apps-services';
import { createPinia } from 'pinia';
import $fetch from './modules/fetch';
import directives from '@v/directives';

import '@ds/vuekit/dist/VUEKIT.css';

import '../assets/scss/global.scss';
import '../assets/css/animations.css';
import '../assets/css/topbar.css';

import { useMeStore } from './stores/me';

export function createApp() {
  // Create App from App.vue
  const app = createSSRApp(App as Component, {
    async onMount() {
      void nextTick().then(() => document.querySelector('.skeleton-container')?.remove());
      const me = useMeStore();
      const passportUrl: string = await $fetch.getServiceURL('3DPassport');

      const query = Object.fromEntries([...new URL(location.href).searchParams.entries()]);
      if (query.ticket) {
        const userData = await loginWithTicket(query.ticket, passportUrl);
        if (userData) {
          me.isMyAppsSynchronizing = true;
          await exportUserToMyApps(userData.attributes.username, userData.justCreated);
          me.isMyAppsSynchronizing = false;
        }
      }

      await me.fetchMe();
      if (me.isLoggedIn && me.me) {
        if (!query.ticket) {
          void exportUserToMyApps(me.me.name as string, false);
        }

        window.dsUserLogin = me.me.name;
        window.synchUser = me.me;

        // If user is a seller, fetch his shops
        if (me.isSeller || me.isPrivateAdmin) {
          await me.fetchMeShops();
        }
      } else {
        window.dsUserLogin = '';
      }
    },
  });
  directives.install(app, { deferTooltips: true });

  // Pinia / Store
  const pinia = createPinia();
  app.use(pinia);
  app.use(router);

  return { app, router };
}
